import WebServiceRequest from "../../../Api/WebServiceRequest";

class GetAPhysicalCategoryProperties extends WebServiceRequest {
  constructor(context) {
    super(context);
  }
  setId(id) {
    super.setTag(
      "PhysicalCategoryProperty/GetPropertiesByCategoryId?physicalCategoryId=" +
        id
    );
  }
}
export default GetAPhysicalCategoryProperties;
